import { useContext } from 'react';
import AuthContext from '../../src/components/context/JWTAuthContext';

const useAuthentication = () => useContext(AuthContext);
console.log("Autneticatin result is ", useAuthentication)
export default useAuthentication;
